import { useEffect, useState } from "react";
import { FadeInWrapper, Footer, LoadingIcon, Main, MainContent, Section } from "@prosolve/common-components-ui";
import useIsMobileView from "../../hooks/useIsMobileView";
import useEmailTemplates from "../Shared/useEmailTemplates";
import useFetchOrders from "../Shared/useFetchOrders";
import EmailTemplates from "./EmailTemplates"
import RunOrderNoficiationButton from "./RunOrderNotificationButton";

const SectionDivider = () => <div style={{ height: '10px' }}>&nbsp;</div>

export default function Email() {
  const isMobileView = useIsMobileView()
  const { fetchEmailTemplates: fetchEmailTemplatesHook } = useEmailTemplates()
  const { fetchOrders } = useFetchOrders();

  const [isLoading, setIsLoading] = useState(false)
  const [isOrderBusy, setIsOrderBusy] = useState(false)
  const [emailTemplates, setEmailTemplates] = useState([])
  const [orderId, setOrderId] = useState('67c8a50991119d27e0ae0f09')
  const [orderEx, setOrderEx] = useState()

  const fetchEmailTemplates = async () => {
    setIsLoading(true)
    const result = await fetchEmailTemplatesHook()
    setEmailTemplates(result)
    setIsLoading(false)
  }

  const fetchOrder = async () => {
    setIsOrderBusy(true)
    const orders = await fetchOrders({ orderId })
    setOrderEx(orders?.[0])
    setIsOrderBusy(false)
  }

  useEffect(() => {
    fetchEmailTemplates()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    fetchOrder()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId])

  return (
    <Main $isMobileView={isMobileView} $backgroundColor={'inherit'} style={{ padding: '10px' }}>
      <MainContent $isMobileView={isMobileView}>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
          <div style={{
            fontSize: '28px',
            fontWeight: 'bold'
          }}>
            {'Manage Emails'}
          </div>
          <div style={{ padding: '15px 0 0 0', fontSize: '1rem' }}>
            <RunOrderNoficiationButton />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', padding: '15px 0 0 0', fontSize: '1rem', minHeight: '32px' }}>
            <span>Order Id: </span>
            <input value={orderId} onChange={e => setOrderId(e.target.value)} style={{ width: '300px' }} />
            {isOrderBusy && <LoadingIcon />}
          </div>
        </div>
        <div style={{ padding: '0px' }}>
        { 
          isLoading 
          ?
          <Section style={{ background: 'inherit', height: '1200px', alignItems: 'center' }}>
            <LoadingIcon />
          </Section>
          :
          !emailTemplates?.length ?
          <Section style={{ background: 'inherit', height: '400px' }}>
            No email templates found
          </Section>
          :
          <FadeInWrapper>
            <Section style={{ background: 'inherit', padding: '0px' }}>
              <EmailTemplates emailTemplates={emailTemplates} orderEx={orderEx} />
            </Section>
          </FadeInWrapper>
        }
        </div>
        <SectionDivider />
        <Footer />
      </MainContent>
    </Main>
  )
}